class PdpIngredientsCarousel {
  constructor(element) {
    this.element = element;
    this.swiper = null;
    this.swiperEl = element.querySelector('.pdp-ingredients-carousel__swiper');
    this.prevEl = element.querySelector('.pdp-ingredients-carousel__nav--prev');
    this.nextEl = element.querySelector('.pdp-ingredients-carousel__nav--next');
    this.init();
  }

  init() {
    if (!this.swiperEl) return;
    if (typeof window.Swiper === 'undefined') {
      requestAnimationFrame(() => this.init());
      return;
    }

    const slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    this.swiper = new window.Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      loop: true,
      navigation: {
        prevEl: this.prevEl,
        nextEl: this.nextEl,
        disabledClass: 'swiper-button-disabled',
      },
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

function initCarousels() {
  document.querySelectorAll('.pdp-ingredients-carousel').forEach((section) => {
    if (!section.pdpIngredientsCarousel) {
      section.pdpIngredientsCarousel = new PdpIngredientsCarousel(section);
    }
  });
}

function initSection(container) {
  const section = container.querySelector?.('.pdp-ingredients-carousel') ?? container.closest?.('.pdp-ingredients-carousel');
  if (!section) return;
  if (section.pdpIngredientsCarousel) section.pdpIngredientsCarousel.destroy();
  section.pdpIngredientsCarousel = new PdpIngredientsCarousel(section);
}

function destroySection(container) {
  const section = container.querySelector?.('.pdp-ingredients-carousel') ?? container.closest?.('.pdp-ingredients-carousel');
  if (section?.pdpIngredientsCarousel) {
    section.pdpIngredientsCarousel.destroy();
    section.pdpIngredientsCarousel = null;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCarousels);
} else {
  initCarousels();
}

document.addEventListener('shopify:section:load', (e) => initSection(e.target));
document.addEventListener('shopify:section:unload', (e) => destroySection(e.target));
